export default [
    {
        path: '/master/currency',
        name: 'currency',
        props: true,
        component: () => import('@/views/master/currency/index.vue'),
        meta: {
            pageTitle: 'Currency',
            breadcrumb: [
                {
                text: 'Currency',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/currency/add',
        name: 'create-currency',
        component: () => import('@/views/master/currency/create.vue'),
        meta: {
            pageTitle: 'Create Currency',
            breadcrumb: [
                {
                text: 'Currency',
                to: { name: 'currency' },
                },
                {
                text: 'Create Currency',
                active: true,
                },
            ],
        },
    },
    {
        path: '/master/currency/:id',
        name: 'detail-currency',
        props: true,
        component: () => import('@/views/master/currency/detail.vue'),
        meta: {
            pageTitle: 'Detail Currency',
            breadcrumb: [
                {
                text: 'Currency',
                to: { name: 'currency' },
                },
                {
                text: 'Detail Currency',
                active: true,
                },
            ],
        },
    },
]